import httpHelper from "@/helpers/httpHelper";

const rankService = {
  async battlePower(data) {
    return await httpHelper.get("/WebApi/Rank/BattlePower", data);
  },
};

export default rankService;
